import { IContract } from "@/types";
import AuthService from "./auth.service";

export default class ContractService {
  static async getContract(params: { contractId: string; serviceGroupId: string }): Promise<IContract | null> {
    try {
      const url = `${process.env.VUE_APP_API_BASE_URL}/system/contract/${params.contractId}/group/${params.serviceGroupId}`;
      const result = await AuthService.api.get(url);
      return result.data;
    } catch (err) {
      console.log("Error fetching contract:", err);
      return null;
    }
  }

  static async getContracts(): Promise<IContract[] | []> {
    try {
      const url = `${process.env.VUE_APP_API_BASE_URL}/system/contracts`;
      const result = await AuthService.api.get(url);
      return result.data;
    } catch (err) {
      console.log("Error fetching contracts:", err);
      return [];
    }
  }

  static async updateContractName(updateContract: IContract): Promise<IContract | null> {
    try {
      const url = `${process.env.VUE_APP_API_BASE_URL}/contract/${updateContract.contractId}/group/${updateContract.serviceGroupId}/change-name`;
      const result = await AuthService.api.post(url, updateContract);
      return result.data;
    } catch (err) {
      console.log("Error fetching contract:", err);
      return null;
    }
  }
}
